import { useState } from 'react';

import { REEL } from '../../../core/constants/landing';
import { SOCIAL_LINKS } from '../../../core/constants/site';
import { IconArrowUpRight, IconPlay } from '../../../common/icons';
import Reveal from '../../../common/components/Reveal/Reveal';
import ViewfinderFrame from '../../../common/components/ViewfinderFrame/ViewfinderFrame';

import '../styles/reel.css';

const YOUTUBE_CHANNEL_HREF = SOCIAL_LINKS.find(link => link.id === 'youtube').href;

export default function Reel() {
    const [isPlaying, setIsPlaying] = useState(false);

    if (!REEL.videoId) return null;

    return (
        <section id="portafolio" className="reel section section--elevated" aria-labelledby="reel-title">
            <div className="container">
                <Reveal className="reel__header">
                    <div>
                        <p className="eyebrow">Portafolio</p>
                        <h2 id="reel-title" className="section__title">Nuestro trabajo en pantalla</h2>
                    </div>
                    <a className="reel__channel" href={YOUTUBE_CHANNEL_HREF} target="_blank" rel="noopener">
                        {REEL.channelLabel}
                        <IconArrowUpRight />
                    </a>
                </Reveal>

                <Reveal className="reel__player">
                    {isPlaying ? (
                        // The YouTube player (and its cookies) loads only after an explicit click,
                        // which is what lets the site ship without a cookie banner.
                        <iframe
                            className="reel__iframe"
                            src={`https://www.youtube-nocookie.com/embed/${REEL.videoId}?autoplay=1&rel=0`}
                            title={REEL.title}
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                            allowFullScreen
                        />
                    ) : (
                        <>
                            <button type="button" className="reel__poster" onClick={() => setIsPlaying(true)}>
                                <span className="reel__ring" aria-hidden="true" />
                                <span className="reel__play"><IconPlay size={28} /></span>
                                <span className="reel__caption">
                                    <span className="sr-only">Reproducir: </span>
                                    {REEL.title}
                                </span>
                            </button>
                            <ViewfinderFrame />
                        </>
                    )}
                </Reveal>

                <p className="reel__note">El video se carga desde YouTube al reproducirlo.</p>
            </div>
        </section>
    );
}
